import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import axios from "axios";
import styles from "./login.module.css";

export const Login = () => {
  const [providers, setProviders] = useState<{ name: string; uri: string }[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation("login");

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/Identity/external/providers`).then(({ data }) => {
      const providers = [];
      for (let name in data) {
        providers.push({
          name,
          uri: data[name],
        });
      }

      if (window.location.href.includes("localhost")) {
        providers[0].uri = providers[0].uri.replace(
          /redirect_uri=(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
          `redirect_uri=${window.location.origin || "https://localhost:4000"}/signedIn`
        );
      }
      setProviders(providers);
      setIsLoading(false);
    });
  }, []);

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>{t("login")}</h1>
      <div className={styles.authButtonsContainer}>
        <h3 className={styles.header}>{t("signInWith")}:</h3>
        {!isLoading &&
          providers.map((provider) => (
            <a href={provider.uri} key={provider.name}>
              <Button>{provider.name}</Button>
            </a>
          ))}
      </div>
    </div>
  );
};
